import { Injectable, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { aplicarResultadoLote, extraParamsFirmaVisiblePades, FicheroLote, parseLoteResult } from './lote-firma.util';

export interface DocumentoParaFirma {
  envioId: number;
  nombre?: string;
  contenido: string;
}

export interface DocumentoFirmado {
  envioId: number;
  contenido: string;
}

@Injectable({ providedIn: 'root' })
export class AutofirmaLoteService {

  constructor(private zone: NgZone, private translate: TranslateService) {}

  private t(key: string): string {
    return this.translate.instant(key);
  }

  firmarDocumentos(documentos: DocumentoParaFirma[]): Promise<DocumentoFirmado[]> {
    if (!documentos?.length) {
      return Promise.reject(new Error(this.t('REMESAS.MSG.SIN_DOCS_FIRMA')));
    }

    const AutoScript = (window as any).AutoScript;
    const Constants = (window as any).Constants;
    if (!AutoScript || typeof AutoScript.cargarAppAfirma !== 'function') {
      return Promise.reject(new Error(this.t('REMESAS.MSG.AUTOFIRMA_NO_DISPONIBLE')));
    }

    const ficheros: FicheroLote[] = documentos.map((d) => ({
      id: `envio-${d.envioId}`,
      nombre: d.nombre || `envio-${d.envioId}.pdf`,
      mime: 'application/pdf',
      base64: d.contenido
    }));

    return new Promise((resolve, reject) => {
      try {
        AutoScript.cargarAppAfirma();
        const base = Constants?.URL_BASE_SERVICES || '';
        if (base) {
          AutoScript.setServlets(
            base + '/afirma-signature-storage/StorageService',
            base + '/afirma-signature-retriever/RetrieveService'
          );
        }
        AutoScript.setLocalBatchProcess(true);
        const extra = extraParamsFirmaVisiblePades();
        AutoScript.createBatch('SHA256withRSA', 'Adobe PDF', 'sign', extra);
        ficheros.forEach((f) => {
          AutoScript.addDocumentToBatch(f.id, f.base64, null, null, extra);
        });
        AutoScript.signBatchProcess(
          false,
          '',
          '',
          '',
          (result: any) => {
            this.zone.run(() => {
              const applied = aplicarResultadoLote(
                ficheros,
                parseLoteResult(result, this.t('REMESAS.MSG.LOT_SIGN_FAIL')),
                this.t('REMESAS.MSG.LOT_NO_RESULT')
              );
              const fallos = applied.filter((f) => !f.firmadoB64);
              if (fallos.length) {
                reject(new Error(fallos[0].error || this.t('REMESAS.MSG.AUTOFIRMA_FALLOS')));
                return;
              }
              resolve(applied.map((f) => ({
                envioId: Number(String(f.id).replace(/^envio-/, '')),
                contenido: f.firmadoB64 as string
              })));
            });
          },
          (_type: string, message: string) => {
            this.zone.run(() => {
              reject(new Error(message || this.t('REMESAS.MSG.AUTOFIRMA_LOTE')));
            });
          }
        );
      } catch (e) {
        reject(new Error(this.t('REMESAS.MSG.AUTOFIRMA_INICIO')));
      }
    });
  }
}
